<template>
    <div style="width: 100%;height:92px;    display: flex;flex-direction: column;
    justify-content: center;border: 1px solid #C5D0E2;text-align: center;
border-radius: 2px;">
        <div style=" font-size: 12px;font-weight: 500;margin-bottom: 8px;">
            <span :class="{isActive: isActiveValue}" :style="{'font-size':fontSize + 'px','margin-right':'4px',color:color}" @click="clickValue">{{ value }}</span>
            {{ unit }}</div>
        <div style="font-size: 12px;color: #0F1A3A;" :class="{isActive: isActiveText}" @click="clickText">{{ title }}</div>
    </div>
</template>
<script>
export default {
    props: {
        title: {
            type: String,
            default: "",
        }, value: {
            type: [String, Number],
            default: "--",
        }, unit: {
            type: String,
            default: "",
        },
        fontSize:{
            type:Number,
            default: 20,
        },
        color:{
            type:String,
            default:"",
        },
        isActiveValue:{
            type:Boolean,
            default:false,
        },
        isActiveText:{
            type:Boolean,
            default:false,
        },
    },
    methods:{
        clickValue(){
            this.$emit("clickValue");
        },
        clickText(){
            this.$emit("clickText");
        }
    },
}
</script>
<style lang="scss" scoped>
.isActive{
    cursor: pointer;
}
.isActive:hover{
    text-decoration: underline;
    color: red !important;
}
</style>